import React, { useEffect, useState } from 'react';
import { checkLimitedInputAuth, startLimitedInputAuth } from '../../connection/limited-device-auth';
import { SIGN_IN_LIMITED_DEVICE, SIGN_IN_PRESENTER, signInLimitedDevice } from '../../stores/actions/session';
import { useDispatch } from 'react-redux';
import { FetchStream } from '../../connection/fetch-stream';

const DeviceAuth = () => {
  const [sessionId, setSessionId] = useState('');
  const [uniqueCode, setUniqueCode] = useState('');
  const [roomId, setRoomId] = useState('');
  const [magicLink, setMagicLink] = useState('');
  const dispatch = useDispatch();
  const eventsApi = process.env.REACT_APP_PLATFORM_API_HOST;

  useEffect(() => {
		FetchStream({
			url: `${eventsApi}/v4/admin/auth/limited-input/start`,
			token: 'foobar',
			method: 'POST'
		}).start(() => {
			console.log('started...');
		}).ended(() => {
			console.log('ended!');
		}).subscribe((data) => {
			console.log('got from subscribe', data);
		}).on('unique-code', (data) => {
			console.log('got custom message', data);
      setUniqueCode(data as unknown as string);
		}).on('magic-link', (data) => {
      console.log('got session id', data);
      setMagicLink(data as unknown as string);
    }).catch(e => {
			console.error(e);
		});
  }, []);

  useEffect(() => {
    const checkAuth = async () => {
      if (!sessionId || !uniqueCode) return;

      const response = await checkLimitedInputAuth(sessionId, uniqueCode);
      if (response.authenticated) {
        clearInterval(intervalId);
        console.log(response);
        setRoomId(response.roomId);
        dispatch(signInLimitedDevice(response.token));
      }
    };

    const intervalId = setInterval(() => {
      checkAuth();
    }, 5000)
    
    return () => clearInterval(intervalId);
  }, [sessionId, uniqueCode]);

  useEffect(() => {
    if (magicLink) {
      window.location.href = `${magicLink}`;
    }
  }, [magicLink]);


  return (
    <div>
      <h1>DeviceAuth</h1>
      <p>Unique Code: {uniqueCode}</p>
      <p>Authenticated: {magicLink ? 'Yes' : 'No'}</p>
    </div>
  );
};

export default DeviceAuth;

